import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LandOwnershipTypesApi from '@/services/apiServiceModules/landOwnershipTypesApi.js'
const landOwnershipTypesApi = new LandOwnershipTypesApi()

export default class LandOwnershipTypesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LAND_OWNERSHIP_TYPES, landOwnershipTypesApi, {
			useCache: true,
		})
	}
}
